export enum EReasonList {
  FOLLOWUP = 'FOLLOWUP',
  ALTERED_MENTAL_STATE = 'ALTERED_MENTAL_STATE',
  FALL = 'FALL',
  FEVER = 'FEVER',
  PAIN = 'PAIN',
  RESPIRATORY_ILLNESS = 'RESPIRATORY_ILLNESS',
  WOUND = 'WOUND',
  OTHER = 'OTHER',
  CONDITION_CHANGE = 'CONDITION_CHANGE',
  MEDICATION = 'MEDICATION',
  SKIN = 'SKIN',
  GASTROINTESTINAL = 'GASTROINTESTINAL',
  URINARY = 'URINARY',
  CONFUSION_DISORIENTATION = 'CONFUSION_DISORIENTATION',
  MEMORY_ISSUE = 'MEMORY_ISSUE',
  ANXIETY_DEPRESSION = 'ANXIETY_DEPRESSION'
}
